import { Button, IconButton, makeStyles, TextField } from "@material-ui/core";
import React, { useCallback, useRef } from "react";
import { MdClose } from "react-icons/md";
import { animarSaidaModal } from "../../functions";
import { useGlobalContext } from "../../hooks";
import { DetalhesContaAPagarExcedido } from "../detalhes-contas-pagar-excedido";

interface IModaAvisoContasExcedentePreConfirmacao {
    sequencial: number;
    onClickConfirmar: () => void;
    fecharModal: () => void;
}

const useThisStyles = makeStyles(theme => ({

    containerModal: {
        position: 'fixed',
        zIndex: 4,
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',

        [theme.breakpoints.down(620)]: {
            padding: '0 1em'
        }

    },

    corpo: {
        backgroundColor: 'white',
        borderRadius: '0.3em',
        boxShadow: '0 0 0 101vw rgba(0,0,0,0.5)',
        maxHeight: '90vh',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden'
    },

    header: {
        padding: '0.3em 1em',
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        fontWeight: 600,
        borderBottom: '1px solid #EEEEEE',
        backgroundColor: '#F03738',
        width: '100%',

        "& svg": {
            width: '1em',
            height: '1em',
            fill: '#fff'
        }

    },

    conteudo: {
        maxWidth: '52ch',
        display: 'flex',
        flexDirection: 'column',
        rowGap: '1.3em',
        padding: '1em',
        flex: 1,
        overflow: 'hidden',
        WebkitOverflowScrolling: 'touch',

        "& span": {
            fontSize: '1.1em',
            color: '#464665',
            textAlign: 'justify'
        },


        [theme.breakpoints.down(620)]: {
            paddingBottom: '0.5em'
        },

    },


    botoes: {

        padding: '1em',
        display: 'grid',
        gridTemplateColumns: 'repeat(2, 1fr)',
        columnGap: '1em',

        "& button": {
            textTransform: 'none',
            height: '3.5em'
        },

        "& button:nth-child(1)": {
            backgroundColor: "#fff",
            color: "#F03738",
            borderColor: "#F03738",

            "&:hover": {
                borderColor: "#980001",
            }
        },

        "& button:nth-child(2)": {
            backgroundColor: "#F03738",
            color: "#fff",
            
            "&:hover": {
                backgroundColor: "#980001",
            }
        },

        [theme.breakpoints.down(620)]: {
            gridTemplateColumns: '1fr',
            rowGap: '1em',

            "& button:nth-child(2)": {
                gridRow: 1
            }
        },
    },

    containerParcelasExcedidas: {
        overflowY: 'auto',
        height: '90%',
        // flex: 1, // só essa parte rola
    },

}));


export const ModalAvisoContasExcedentePreConfirmacao: React.FC<IModaAvisoContasExcedentePreConfirmacao> = ({
    sequencial,
    onClickConfirmar,
    fecharModal
}) => {

    const classes = useThisStyles();

    const {
        parcelasContasAPagarExcedido
    } = useGlobalContext();

    const refModal = useRef<HTMLElement>(null);

    const handleClickCancelar = async () => {

        await animarSaidaModal(refModal);

        fecharModal();

    }

    const handleClickConfirmar = async () => {

        await animarSaidaModal(refModal);

        onClickConfirmar();

        fecharModal();
    }

    return <article className={classes.containerModal}>

        <section ref={refModal} className={`${classes.corpo} zoomIn`}>

            <div className={classes.header}>

                <p>Alerta</p>

                <IconButton
                    onClick={handleClickCancelar}
                >
                    <MdClose />
                </IconButton>

            </div>

            <div className={classes.conteudo}>

                <span>
                    Esta solicitação contem parcelas do contas a pagar que excedem o valor limite mensal de compra do departamento!
                    Deseja liberar mesmo assim?
                </span>
                <div className={classes.containerParcelasExcedidas}>
                    <DetalhesContaAPagarExcedido
                        detalhes={parcelasContasAPagarExcedido}
                    />
                </div>

            </div>

            <div className={classes.botoes}>

                <Button
                    variant="outlined"
                    color="primary"
                    onClick={handleClickCancelar}
                >
                    Cancelar
                </Button>

                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleClickConfirmar}
                >
                    Confirmar
                </Button>

            </div>

        </section>

    </article>

}